<div class="flex flex-col p-6">
  <div class="flex flex-row gap-16">
    @if (displayCard$ | async) {
      <app-quote-card [shipment]="shipment" [quote]="quote"></app-quote-card>
    }
    <div class="flex flex-col gap-8">
      @if (result === null) {
        <div>
          @if (errors.length == 0) {
            <div class="title" i18n>
                    Ready to Ship
                </div>
          }
          @if (errors.length > 0) {
            <div class="title" i18n>
                    Unable to Submit Shipment
                </div>
          }
          <div>
            <dl>
              <dt i18n>Courier</dt>
              <dd>{{ quote.courierName }}</dd>
              <dt i18n>Service</dt>
              <dd>{{ quote.serviceName }}</dd>
            </dl>
          </div>
          @if (violations.length > 0) {
            <div>
              @for (violation of violations; track violation) {
                <div>
                  <div class="warn">
                    <app-icon icon="warning"></app-icon>
                    <span>{{ violation.message }}</span>
                  </div>
                </div>
              }
              <div class="instruction" i18n>
                        Please resolve the above problems before shipping
                    </div>
            </div>
          }
          @if (exception) {
            <div>
              @if (exception == quoteNotFoundException) {
                <div>
                  <ul class="warn fa-ul">
                    <li>
                      <span class="fa-li"><app-icon icon="warning"></app-icon></span>
                      <span i18n>
                                The quote you selected is no longer available.  It may have expired.
                                Please requote this shipment and try again.
                                </span>
                    </li>
                  </ul>
                </div>
              }
            </div>
          }
          @if (errors.length > 0) {
            <div>
              @for (message of errors; track message) {
                <app-server-message [message]="message"></app-server-message>
              }
              <div class="instruction" i18n>
                        Please review these errors and make the necessary corrections or ship with an alternative carrier
                    </div>
            </div>
          }
        </div>
      }
      @if (!!result) {
        <div>
          <div class="title" i18n>
                    Successfully Submitted Shipment
                </div>
          <div>
            <dl>
              <dt i18n>Courier</dt>
              <dd>{{ quote.courierName }}</dd>
              <dt i18n>Service</dt>
              <dd>{{ quote.serviceName }}</dd>
              <dt i18n>Master Tracking Number</dt>
              <dd>{{ result.trackingNumber }}</dd>
            </dl>
          </div>
        </div>
      }
    </div>
  </div>
  <div class="buttons flex justify-end gap-4">
    <button mat-button (click)="close()">CLOSE</button>
    @if (!!result && result.documents.length > 0) {
      <button mat-raised-button color="primary" (click)="printWaybills()" i18n>
            PRINT WAYBILLS
        </button>
    }
    @if (result === null && violations.length == 0 && errors.length == 0) {
      <button mat-raised-button color="primary" (click)="ship()" [disabled]="busy$ | async">
        <span i18n>SUBMIT</span>
        @if (busy$ | async) {
          <app-icon icon="spinner" [spin]="true"></app-icon>
        }
      </button>
    }
  </div>
</div>
